// ** React Imports
import { Fragment } from "react"

// ** Custom Components
import NavbarUser from "./NavbarUser"
const ThemeNavbar = (props) => {
	// ** Props
	const { skin, setSkin, setMenuVisibility, cfilters, themeChange, title, data } = props;
	return (
		<Fragment>
			<NavbarUser skin={skin} setSkin={setSkin} setMenuVisibility={setMenuVisibility} cfilters={cfilters} themeChange={themeChange} />
		</Fragment>
	)
}

export default ThemeNavbar
